export class Reverb {
    constructor(ctx) {
        this.ctx = ctx;
        this.input = this.ctx.createGain();
        this.output = this.ctx.createGain();
        this.convolver = this.ctx.createConvolver();
        this.wet = this.ctx.createGain();
        this.dry = this.ctx.createGain();
        
        // Routing
        this.input.connect(this.dry);
        this.input.connect(this.convolver);
        this.convolver.connect(this.wet);
        
        this.dry.connect(this.output);
        this.wet.connect(this.output);
        
        // Defaults
        this.dry.gain.value = 1.0;
        this.wet.gain.value = 0.0;
        
        this.generateImpulse(2.0, 2.0); // Default 2s decay
    }

    setup() {
        return Promise.resolve();
    }

    getInput() {
        return this.input;
    }

    getOutput() {
        return this.output;
    }

    setMix(value) {
        // value 0.0 - 1.0
        this.wet.gain.value = value;
        this.dry.gain.value = 1.0 - (value * 0.5); // Slight dip in dry to compensate
    }

    setDecay(duration) {
        this.generateImpulse(duration, 2.0);
    }

    generateImpulse(duration, decay) {
        const rate = this.ctx.sampleRate;
        const length = rate * duration;
        const impulse = this.ctx.createBuffer(2, length, rate);
        const left = impulse.getChannelData(0);
        const right = impulse.getChannelData(1);

        for (let i = 0; i < length; i++) {
            const n = i; // sample index
            // Exponential decay
            // const e = Math.pow(1 - n / length, decay);
            // Simple exponential decay function: e^(-k * t)
            const t = i / rate;
            const envelope = Math.pow(0.01, t / duration); // Decay to 0.01 (-40dB) by duration

            // Random noise
            left[i] = (Math.random() * 2 - 1) * envelope;
            right[i] = (Math.random() * 2 - 1) * envelope;
        }

        this.convolver.buffer = impulse;
    }
}
